//pages/KitchensLandingSR.jsx
import React, { useEffect, useMemo, useState, useRef } from "react"; // Dodajte useRef
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import LeadForm from "../components/LeadForm/LeadForm";
import { getConsent } from "../analytics/tracker"; 


// na vrhu fajla (već imaš):
const STATIC_BASE   = process.env.REACT_APP_STATIC_BASE || ""; // za lokalno je ""
const VIEWER_PREFIX = "/demo3d";

// mali helper komponent za thumb sa fallback-ovima
function Thumb({ code, alt }) {
  const candidates = [
    `${STATIC_BASE}/demo/thumbnails/${code}.png`,
    `${STATIC_BASE}/demo/thumbnails/${code}.jpg`,
    `${STATIC_BASE}/demo/thumbnails/${code}.webp`,
    `${STATIC_BASE}/demo/thumbnails/placeholder.png`,
  ];
  const [idx, setIdx] = React.useState(0);

  const src = candidates[idx];

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="w-full h-full object-cover transition-transform group-hover:scale-105"
      onError={() => {
        console.warn("Thumb 404:", src);
        setIdx(i => Math.min(i + 1, candidates.length - 1));
      }}
    />
  );
}

function DemoModelsInlineGallery({ limit = 8 }) {
  const [models, setModels] = React.useState([]);
const { t } = useTranslation();
  React.useEffect(() => {
    fetch(`${STATIC_BASE}/demo/3dmodels/models.json`)
      .then(r => (r.ok ? r.json() : []))
      .then(list => setModels(Array.isArray(list) ? list.slice(0, limit) : []))
      .catch(console.error);
  }, [limit]);

  if (!models.length) return null;

  return (
    <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3">
  {models.map(m => {
    const code = (m.Code || m.code || "").trim();
    const name = m.Name || m.name || code;
    return (
      <Link
        key={code}
        to={`${VIEWER_PREFIX}/${code}`}
        className="group relative block aspect-square rounded-lg overflow-hidden
             border border-slate-200 dark:border-slate-700
             bg-white dark:bg-slate-800
             bg-gradient-to-br from-slate-100 to-slate-200
             dark:from-slate-900 dark:to-slate-800"
      >
        {/* Ako u JSON-u ima direktan Thumb URL, koristi njega; inače fallback lanac */}
        {m.Thumb || m.Thumbnail ? (
          <img
            src={`${STATIC_BASE}${(m.Thumb || m.Thumbnail).startsWith('/') ? (m.Thumb || m.Thumbnail) : '/' + (m.Thumb || m.Thumbnail)}`}
            alt={name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform group-hover:scale-105"
            onError={(e) => { 
              console.warn("JSON thumb 404:", e.currentTarget.src);
              // pređi na naš Thumb fallback lanac
              e.currentTarget.replaceWith(
                Object.assign(document.createElement('img'), {
                  src: `${STATIC_BASE}/demo/thumbnails/${code}.png`,
                  alt: name,
                  loading: 'lazy',
                  className: 'w-full h-full object-cover transition-transform group-hover:scale-105'
                })
              );
            }}
          />
        ) : (
          <Thumb code={code} alt={name} />
        )}

        <div className="absolute bottom-0 inset-x-0 bg-black/50 text-white text-xl px-2 py-1 truncate">
          {t("landing.demo_3dinteractivmodels_title")}
        </div>
      </Link>
    );
  })}
</div>

  );
}


export default function KitchensLandingSR() {
    const { t } = useTranslation();
    const fileInputRef = useRef(null);
    function handleOpenPicker() {
        fileInputRef.current?.click();
    }
  // ➕ dodali smo honeypot "website"
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
    website: "", // honeypot (botovi će puniti)
  });

  // ➕ dodali smo i code + gclid + qr
  const [utm, setUtm] = useState({
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_content: "",
    utm_term: "",
    gclid: "",
    qr: "",
    qr_id: "",
    code: "",
  });

  const MAILSERVER_API = "https://modularobjects.com/mailserver";

  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [apiResult, setApiResult] = useState(null);

  const firedRef = useRef(false);
 

  
  // state
const [files, setFiles] = useState([]);

// helper validacija
const MAX_SIZE = 10 * 1024 * 1024; // 10MB po fajlu
const ALLOWED = ["image/jpeg","image/png","image/webp","application/pdf"];

function fireAdsConversion() {
  const send = () => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-17534918048/_fhiCOLimJUbEKC7pqlB",
        value: 1.0,
        currency: "RSD",
      });
      return true;
    }
    return false;
  };

  if (send()) return;
  let tries = 10;
  const iv = setInterval(() => {
    if (send() || --tries <= 0) clearInterval(iv);
  }, 300);
}


function onPick(e) {
    console.log('onPick', e.target.files?.length);
  const picked = Array.from(e.target.files || []);
  const MAX_SIZE = 10 * 1024 * 1024;
  const ALLOWED = ["image/jpeg","image/png","image/webp","application/pdf"];

  const safe = [];
  for (const f of picked) {
    if (f.size > MAX_SIZE) { alert(`${f.name}: >10MB`); continue; }
    if (!ALLOWED.includes(f.type)) { alert(`${f.name}: nedozvoljen tip`); continue; }
    safe.push(f);
  }

  setFiles(prev => [...prev, ...safe].slice(0, 10));

  // 👇 obavezno – dozvoljava ponovno biranje istih fajlova
  e.target.value = "";
}

function fireAdsConversion() {
  const send = () => {
    console.log('[ADS] firing conversion…', window.gtag ? 'gtag OK' : 'gtag MISSING');
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17534918048/_fhiCOLimJUbEKC7pqlB',
        value: 1.0,
        currency: 'RSD',
        event_callback: () => console.log('[ADS] conversion sent')
      });
      return true;
    }
    return false;
  };

  // pokušaj odmah, pa još par puta u kratkim razmacima
  if (send()) return;
  let tries = 10;
  const iv = setInterval(() => {
    if (send() || --tries <= 0) clearInterval(iv);
  }, 300);
}



  // ⛳️ UTM + code + gclid + qr iz URL-a
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setUtm({
      utm_source:  params.get("utm_source") || "",
      utm_medium:  params.get("utm_medium") || "",
      utm_campaign:params.get("utm_campaign") || "",
      utm_content: params.get("utm_content") || "",
      utm_term:    params.get("utm_term") || "",
      gclid:       params.get("gclid") || "",
      qr:         (params.get("qr") || ""),
      qr_id:     (params.get("qr_id") || ""),
      code:       params.get("code") || "",
    });
  }, []);

// ✅ definicija regexa van useMemo (samo jednom)
const phoneRe = /^[0-9+()\s-]{6,}$/;

const canSubmit = useMemo(() => {
  const phoneOk = phoneRe.test(form.phone.trim());
  const nameOk = form.name.trim().length >= 2;
  console.log('Phone:', form.phone, 'Valid:', phoneOk);
  console.log('Name:', form.name, 'Valid:', nameOk);
  console.log('Submitting:', submitting);
  console.log('Can submit:', phoneOk && nameOk && !submitting);
  return phoneOk && nameOk && !submitting;
}, [form, submitting]);

async function onSubmit(e) {
  e.preventDefault();

  if (form.website?.length > 0) { setError("Greška pri slanju. Pokušajte ponovo."); return; }

  const phoneOk = phoneRe.test(form.phone.trim());
  const nameOk = form.name.trim().length >= 2;
  if (!phoneOk || !nameOk || submitting) {
    setError("Molimo popunite obavezna polja ispravno.");
    return;
  }
  

  setSubmitting(true);
  setError("");
  setApiResult(null);
  setDone(false);

  const payload = {
    code: utm.code,
    name: form.name.trim(),
    email: form.email?.trim() || null,
    phone: form.phone?.trim() || null,
    message: form.message?.trim() || null,
    utm_source: utm.utm_source,
    utm_medium: utm.utm_medium,
    utm_campaign: utm.utm_campaign,
    utm_content: utm.utm_content,
    utm_term: utm.utm_term,
    gclid: utm.gclid,
    qr: utm.qr,
    qr_id: utm.qr_id,
    page_url: window.location.href,
  };

  try {
    const controller = new AbortController();
    const t = setTimeout(() => controller.abort(), 15000);

    const response = await fetch(`${MAILSERVER_API}/api/leads`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      credentials: "include",
      signal: controller.signal,
    });
    clearTimeout(t);

    let result = null; let rawText = "";
    try { result = await response.json(); }
    catch { rawText = await response.text().catch(() => ""); }

    if (!response.ok || !result?.ok) {
      const msg = result?.message || rawText || `HTTP ${response.status}`;
      throw new Error(msg);
    }

    setApiResult(result);
    const leadId = result?.id;

    // ✅ OKINI KONVERZIJU ODMAH (pre upload-a)
if (!firedRef.current) {
  fireAdsConversion();
  firedRef.current = true;

  // (opciono) GA4 backup signal – kasnije uvezi u Ads
  window.gtag?.('event', 'generate_lead', { value: 1.0, currency: 'RSD' });
}

    if (leadId && files.length > 0) {
      const fd = new FormData();
      files.forEach(f => fd.append("files", f));

      const up = await fetch(`${MAILSERVER_API}/api/leads/${leadId}/files`, {
        method: "POST",
        body: fd,
        credentials: "include",
      });

      let upJson = null, upTxt = "";
      try { upJson = await up.json(); } catch { upTxt = await up.text().catch(()=> ""); }
      if (!up.ok || upJson?.ok === false) {
        console.warn("Upload nije uspeo:", upJson?.message || upTxt || up.status);
      }
    }



if (!firedRef.current) {
  fireAdsConversion();
  firedRef.current = true;
}
    



    setError("");
    setDone(true);
    setForm({ name:"", phone:"", email:"", message:"", website:"" });
    setFiles([]);
    firedRef.current = false; // 👈 dozvoli novi submit

  } catch (err) {
    console.error("Lead submit error:", err);
    setError("Došlo je do greške. Pokušajte ponovo ili nas pozovite.");
  } finally {
    setSubmitting(false);
  }
}




  return (
    <main className="min-h-screen 
                 bg-background-light text-text-light 
                 dark:bg-background-dark dark:text-text-dark">
      {/* JSON-LD – LocalBusiness (prilagodite podatke!) */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "Modular Objects – Kuhinje po meri",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Dr Ivana Ribara 125",
              addressLocality: "Beograd",
              addressCountry: "RS",
            },
            url: "https://www.modularobjects.com/kuhinje",
            telephone: "+381 62 8541543",
            areaServed: "Beograd, Srbija",
            sameAs: [
              "https://www.facebook.com/profile.php?id=61568893899955",
              "https://www.instagram.com/kuhinja_po_vasoj_meri/",
              "https://www.youtube.com/@modularobjects",
            ],
            image: [
              "https://www.modularobjects.com/public/kitchen_gallery/black_kitchen.jpg",
            ],
            description:
              "Izrada i montaža kuhinja po meri – besplatan 3D plan, brza isporuka, kvalitetni materijali.",
          }),
        }}
      />

      {/* Hero */}
      <section className="mx-auto max-w-6xl px-4 py-12 md:py-20 grid md:grid-cols-2 gap-8 items-center">
  <div>
    <h1 className="text-4xl md:text-5xl font-extrabold leading-tight">
  {t("landing.hero_title")}{" - "}{t("landing.hero_emphasis")}
   {/*<span className="text-primary-light dark:text-primary-dark">
   {t("landing.hero_emphasis")}
  </span>*/}
</h1>

<h2 className="mt-6 text-2xl md:text-3xl font-extrabold leading-tight">
  <span className="text-primary-light dark:text-primary-dark">
    {t("landing.hero_subline")}
  </span>
</h2>

<p className="mt-4 text-lg text-text-light dark:text-text-dark/80">
  {t("landing.hero_p")}
</p>

<ul className="mt-6 space-y-2 text-text-light dark:text-text-dark/80">
  {t("landing.hero_bullets", { returnObjects: true }).map((b, i) => <li key={i}>• {b}</li>)}
</ul>

<div className="mt-6 flex flex-wrap gap-3">
  <a href="#form" className="rounded-xl bg-slate-900 text-white px-5 py-3 font-semibold hover:bg-slate-800">
    {t("landing.cta_model")}
  </a>
  <a href="#galerija" className="rounded-xl border border-slate-300 px-5 py-3 font-semibold hover:bg-slate-100">
    {t("landing.cta_gallery")}
  </a>
</div>
  </div>

  <div className="aspect-[4/4] w-full rounded-2xl bg-background-light dark:bg-background-dark overflow-hidden">
    <img
      src="https://modularobjects.com/public/kitchen_gallery/black_kitchen.jpg"
      alt="Moderna kuhinja po meri"
      className="w-full h-full object-cover"
    />
  </div>
</section>


      {/* Value props */}
      <section className="mx-auto max-w-6xl px-4 py-10 grid md:grid-cols-3 gap-6">
  {t("landing.value_props", { returnObjects: true }).map((b, i) => (
    <div
      key={i}
      className="rounded-2xl border border-slate-200 dark:border-gray-700 
                 p-6 bg-background-light dark:bg-background-dark shadow-sm"
    >
      <h3 className="font-semibold text-lg text-text-light dark:text-text-dark">{b.title}</h3>
      <p className="mt-2 text-text-light dark:text-text-dark">{b.desc}</p>
    </div>
  ))}
</section>

      {/* Steps */}
      <section className="mx-auto max-w-6xl px-4 py-10" aria-labelledby="steps">
  <h2
    id="steps"
    className="text-2xl font-bold text-text-light dark:text-text-dark"
  >
    {t("landing.steps_title")}
  </h2>
  <div className="mt-6 grid md:grid-cols-3 gap-6">
    {t("landing.steps", { returnObjects: true }).map((s) => (
      <div
        key={s.step}
        className="rounded-2xl border border-slate-200 dark:border-gray-700 
                   p-6 bg-background-light dark:bg-background-dark"
      >
        <div className="w-10 h-10 rounded-full bg-slate-900 text-white flex items-center justify-center font-bold">
          {s.step}
        </div>
        <h3 className="mt-4 font-semibold text-lg text-text-light dark:text-text-dark">
          {s.title}
        </h3>
        <p className="mt-2 text-text-light dark:text-text-dark">{s.desc}</p>
      </div>
    ))}
  </div>
</section>


      {/* Gallery */}
<section id="galerija" className="mx-auto max-w-6xl px-4 py-10">
  <h2 className="text-2xl font-bold">
    {t("landing.gallery_title")}
  </h2>
  <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3">
    {Array.from({ length: 8 }).map((_, i) => (
      <div key={i} className="aspect-square rounded-lg overflow-hidden bg-slate-200">
        <img
          src={`https://modularobjects.com/public/kitchen_gallery/kitchen${i + 1}.jpg`}
          alt={`${t("landing.gallery_alt")} ${i + 1}`}
          className="w-full h-full object-cover"
        />
      </div>
    ))}
  </div>
</section>

{/* Demo modeli (klik vodi na 3D viewer) */}
<section id="demo-models" className="mx-auto max-w-6xl px-4 py-10">
  <h2 className="text-2xl font-bold">{t("landing.demo_3dmodels_title")}</h2>
  <DemoModelsInlineGallery limit={4} />
</section>



    {/* Lead form */}
<section id="form" className="mx-auto max-w-3xl px-4 py-12">
  <LeadForm
    mailserverApi={MAILSERVER_API}
    
    context={{ page: "kitchens_landing_sr" }}
  onSuccess={({ apiResult, error }) => {
    if (error) return;
    if (!(apiResult?.ok || apiResult?.needsVerification)) return;

    track(EV.LEAD_SUBMIT_SUCCESS, {
      ...getConsent(),
      contact_id: apiResult?.contactId || apiResult?.contact_id || null,
      metadata: {
        page: "kitchens_landing_sr",
        surface: "lead_form",
        ok: !!apiResult?.ok,
        needsVerification: !!apiResult?.needsVerification,
      },
    });
  }}

    conversion={() => {
      fireAdsConversion();
      window.gtag?.("event", "generate_lead", { value: 1.0, currency: "RSD" });

       track(EV.LEAD_SUBMIT_SUCCESS, {
            ...getConsent(),
        metadata: {
          action: "lead_submit_success",
          page: "projects",
          ok: !!apiResult?.ok,
          needsVerification: !!apiResult?.needsVerification,
        },
      });
    }}

    
  />
</section>

      {/* FAQ */}
      <section className="mx-auto max-w-6xl px-4 pb-20">
  <h2 className="text-2xl font-bold text-text-light dark:text-text-dark">
    {t("landing.faq_title")}
  </h2>
  <div className="mt-6 grid md:grid-cols-2 gap-6">
    {t("landing.faq_items", { returnObjects: true }).map((f, i) => (
      <div
        key={i}
        className="rounded-2xl border p-6 shadow-sm bg-background-light dark:bg-background-dark border-slate-200 dark:border-neutral-800"
      >
        <h3 className="font-semibold text-text-light dark:text-text-dark">
          {f.q}
        </h3>
        <p className="mt-2 text-text-light/80 dark:text-text-dark/80">
          {f.a}
        </p>
      </div>
    ))}
  </div>
</section>
    </main>
  );
}
